import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetShopWiningType } from '../betShopWiningType';
import { BetShopCardsSection } from '../betShopCardsSection';
import { BetShopSideCounts } from '../betShopSideCounts';
import { winningAmountStore } from '../../store/winningAmountStore';

export const BetShopSecondView = observer(() => {
  const { winType, isPairWin } = winningAmountStore;

  return (
    <div className='bb-desktop-two'>
      {winType !== null && <BetShopWiningType winType={winType} isPairWin={isPairWin} />}
      <BetShopCardsSection />
      <BetShopSideCounts />
    </div>
  );
});
